import { Component, OnInit, Input, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-master-rail-one',
    templateUrl: './master-rail-one.component.html',
    styleUrls: ['./master-rail-one.component.scss']
})
export class MasterRailOneComponent implements OnInit {

    @Input('learner') learner;
    @Input('job') job;
    @Input('courseComponet') courseComponet;
    @Input('assessment') assessmentPlanEdit;
    @Input('summarySheetEdit') summarySheetEdit
    courseComponetName: any;
    learnerId: any;
    jobData:any;
    jobId: any;
    assessmentEdit: any;
    layout = false    
    constructor() { }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        console.log("changes in master rail main", changes);
        if (changes.learner && changes.learner.currentValue) {
            this.learnerId = changes.learner.currentValue._id
        }

        if (changes.job && changes.job.currentValue) {
            this.jobId = changes.job.currentValue[0]._id
            this.jobData = changes.job.currentValue
        }
        if (changes.courseComponet && changes.courseComponet.currentValue) {
            console.log("course component name")
            this.courseComponetName = changes.courseComponet.currentValue;
        }

        if (changes.summarySheetEdit && changes.summarySheetEdit.currentValue) {
            this.summarySheetEdit = changes.summarySheetEdit.currentValue
        }

        if (changes.assessmentPlanEdit && changes.assessmentPlanEdit.currentValue) {
            console.log("changes.assessmentPlanEdit.currentValue in master", changes.assessmentPlanEdit.currentValue)
            this.assessmentEdit = changes.assessmentPlanEdit.currentValue
            console.log("assement plan edit data", this.assessmentEdit);
        }
        if (changes.courseComponet && changes.courseComponet.currentValue) {
            console.log("course component name")
            this.courseComponetName = changes.courseComponet.currentValue;
            console.log("course component name",this.courseComponetName)
        }
    }
}
